import { ICardContainer } from "@/components/Card/card.interface";
import { styled, Typography } from "@mui/material";
import CardContainer from "../CardContainer";

const CustomFormCardLabel = styled(Typography)(({ theme }) => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontSize: "1.1rem",
  fontFamily: "Poppins,sans-serif",
  fontWeight: 600,
  pointerEvents: "auto",
  lineHeight: "1.4375em",
  letterSpacing: "0.00938em",
  display: "block",
  color: theme.palette.text.primary,
}));
export default function FormCard({ label, children, sx, ...rest }: FormCardProps) {
  return (
    <CardContainer sx={{ padding: 3, gap: 2, ...sx }} {...rest}>
      <CustomFormCardLabel>{label}</CustomFormCardLabel>
      {children}
    </CardContainer>
  );
}

interface FormCardProps extends ICardContainer {
  label: string;
  children: React.ReactNode;
}
